import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { GetContentCollectionsQuery, GetContentCollectionsQueryVariables } from '@/types/codegen-federation'
import { logger } from '@/utils/logging'
import { GET_CONTENT_COLLECTIONS } from './queries'
import { ContentCollection, ContentCollections } from './types'

export const getContentCollections = async (
  ids: string[],
  client: ApolloClient<NormalizedCacheObject>,
): Promise<ContentCollections> => {
  try {
    const { data } = await client.query<GetContentCollectionsQuery, GetContentCollectionsQueryVariables>({
      query: GET_CONTENT_COLLECTIONS,
      variables: { ids, first: 50, after: null },
      errorPolicy: 'all',
    })

    if (!data?.contentCollections) return []
    return data.contentCollections.filter(isValidContentCollection)
  } catch (error) {
    logger().error('Error fetching content collections', { ids }, error)
    return []
  }
}

export const isValidContentCollection = (collection: ContentCollection | null | undefined): boolean => {
  return !!(collection?.title && collection?.connection?.edges?.length)
}
